import * as ScrollArea from '@radix-ui/react-scroll-area'
import * as TabSectionPrimitive from '@radix-ui/react-tabs'
import { forwardRef } from 'react'
import { cn } from '#app/utils/misc'

const TabSection = TabSectionPrimitive.Root
const TabContent = TabSectionPrimitive.Content

const TabList = forwardRef<
  React.ElementRef<typeof TabSectionPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabSectionPrimitive.List>
>(({ className, children, ...props }, ref) => (
  <ScrollArea.Root>
    <ScrollArea.Viewport className="border-b border-gray-6">
      <TabSectionPrimitive.List
        ref={ref}
        className={cn('-mb-px mt-4 flex space-x-3 border-b border-gray-6 md:space-x-10', className)}
        {...props}
      >
        {children}
      </TabSectionPrimitive.List>
    </ScrollArea.Viewport>
    <ScrollArea.Scrollbar orientation="horizontal">
      <ScrollArea.Thumb />
    </ScrollArea.Scrollbar>
  </ScrollArea.Root>
))
TabList.displayName = TabSectionPrimitive.List.displayName

const TabListItem = forwardRef<
  React.ElementRef<typeof TabSectionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabSectionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <TabSectionPrimitive.Trigger
    ref={ref}
    className={cn(
      'text-body group whitespace-nowrap border-b-2 border-transparent px-2 py-4 text-gray-11 hover:border-gray-8 hover:text-gray-12 data-[state=active]:border-accent-9 data-[state=active]:text-accent-9',
      className,
    )}
    {...props}
  >
    {children}
  </TabSectionPrimitive.Trigger>
))
TabListItem.displayName = TabSectionPrimitive.Trigger.displayName

export { TabSection, TabList, TabListItem, TabContent }
